var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimbolicGrafic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 32,
    viewBox: "0 0 324 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.682 0.0170025C76.4259 0.587014 22.8706 27.7249 0 32H324V4.07819C310.659 4.7907 241.094 11.2747 226.8 16.2623C212.506 21.2499 146.753 -0.695512 107.682 0.0170025Z",
    fill: "#0C8CE9",
    fillOpacity: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimbolicGrafic);
export default __webpack_public_path__ + "static/media/simbolic_grafic.2315a0026be2889e4e4c53f489c5b4b2.svg";
export { ForwardRef as ReactComponent };